// src/modules/app-views/dataSearch/pages/Historic/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
// import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
// No constants needed

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************

/**
 * Menu button configuration for DataSearch Historic page
 * Returns dropdown menu configuration for the page header
 */
function dataSearchHistoricMenuButton() {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      // dropdownParameters,
    ],
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default dataSearchHistoricMenuButton;
